import { graphqlClient } from '@topconagriculture/graphql-client';
import { PermissionChecker } from '@topconagriculture/casbin-adapter';
export const permissionsInstanceSetup = (() => {
    let instance;
    const setup = async (userId, tenant) => {
        instance = new PermissionChecker(graphqlClient.getClient('graphqlClient'), userId, tenant, '');
        await instance.initialize();
        return instance;
    };
    const getInstance = () => instance;
    return {
        getInstance,
        setup,
    };
})();
//# sourceMappingURL=permissionsChecker.js.map